import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchAddOperations } from 'hooks/batchOperations';

type ImageContent = {
  imageUrl: string | undefined;
  sortOrder: number;
};

type mutationVariables = {
  sparkImageUrls: ImageContent[];
};

export function useAddBatchSparkImages(sparkID: string | undefined) {
  const queryClient = useQueryClient();
  const { mutateAsync: addBatchSparkImages } = useBatchAddOperations();

  const addSparkImages = ({ sparkImageUrls }: mutationVariables) => {
    if (!sparkID) {
      Promise.reject('SparkID can not be null');
    }
    const sparkImageArray = sparkImageUrls.map((url) => ({
      type: SPARK_RESOURCE_TYPES.SPARK_IMAGES,
      attributes: { imageURL: url.imageUrl, sortOrder: url.sortOrder, sparkID },
    }));

    return addBatchSparkImages(sparkImageArray);
  };

  return useMutation('addSparkImages', addSparkImages, {
    onSuccess: () => {
      queryClient.invalidateQueries(['sparks', sparkID]);
      queryClient.invalidateQueries(['sparkDiagnostics']);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post Spark images: ${error.message}`);
      }
    },
  });
}
